const localizers = {
  'loading.msg': () => `A carregar...`,
  'logon.message.msg': () => `A autenticação é necessária. Introduza um ID de utilizador e uma palavra-passe válidos.`,
  'logon.button.msg': () => `Iniciar sessão...`,
  'SASServer.logonError.msg': () => `Não foi possível iniciar sessão no servidor.`,
  'SASServer.genericError.msg': () => `Não foi possível contactar o servidor.`,
}
export default localizers;
